import { ArrowBack } from '@mui/icons-material'
import { Button, IconButton, Stack, Typography } from '@mui/material'
import type { FC } from 'react'

type Props = {
  onBack: () => void
  onSave?: () => void
  canSave?: boolean
}

export const EditHeader: FC<Props> = ({ onBack, onSave, canSave = true }) => {
  return (
    <Stack
      sx={{
        height: 64,
        minHeight: 64,
        px: 2,
        bgcolor: 'white',
        boxShadow: 'none',
        borderBottom: 1,
        borderColor: 'divider',
      }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton onClick={onBack} size="small">
          <ArrowBack />
        </IconButton>
        <Typography
          variant="h1"
          sx={{
            color: 'text.primary',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
        >
          ラベルマスタ
        </Typography>
      </Stack>
      <Button
        variant="text"
        color="primary"
        size="large"
        disabled={!canSave}
        onClick={onSave}
        sx={{ fontWeight: 'bold' }}
      >
        保存
      </Button>
    </Stack>
  )
}
